const Form101TC = {
    stepName: {
        importantNotes: "重要事项",
        post: "申请职位",
        personalParticulars: "个人资料",
        educationQualifications: "就学详情及相关学历",
        bachelorAndMaster: "学士及硕士学位",
        teacherTraining: "教师培训及专业资格",
        languageProficiency: "语文能力及其他测试",
        supplementaryInformation: "补充资料 (适用于特定职位)",
        workingExperience: "工作经验",
        otherInformation: "其他资料 (可选择是否填写)",
        supportingDocument: "证明文件",
        declaration: "声明",
        confirmation: "确认",
    },
    importantNotes: {
        title: "申请人须知",
        title1: "一般注意事项",
        title2: "填交申请时的注意事项",
        title3: "递交申请后的注意事项",
        title4: "查询",
    },
    importantNotesStep: [
        {
            textBefore: "使用本系统进行网上申请时，请先参阅「",
            text: "电脑系统配置",
            textAfter: "」有关系统及电脑配置的要求。",
        },
        {
            text: "教育局会在你成功递交整份网上申请书、更改申请资料或递交补充资料后<b>2小时内</b>以电邮确认你递交的资料已获受理。为确保申请书及确认通知传递无误，你<b>必须</b>于网上申请书内填写<b>正确</b>的电邮地址。你在此后不能在网上更改电邮地址。",
        },
        {
            text: "你只会在递交整份网上申请书后才获发网上参考编号。日后与教育局聘用及人事组联络时，请引述你的网上参考编号。",
        },
        {
            text: "你必须填报申请书内要求提供的所有个人资料，但注明是可选择是否填报的资料则属例外。教育局可能要求你就特定项目提供详细资料，以支持申请个别职位。你必须参阅招聘广告内列出的有关要求填写本申请书。如你未能提供所要求的所有资料，或所提供的资料未能清楚显示你具备有关职位所规定最起码的学历、训练、经验或其他条件，<u>申请书将不获受理</u>。",
        },
        {
            text: "你在本申请书内所提供的个人资料，将用于招聘工作，以及其他与僱用和人力资源管理有关的事宜上。如有需要，有关资料可能会送交获授权处理有关资料的政府部门及其他组织或机构，用以进行与政府招聘工作及僱用有关的事宜，例如学历评审、体格检查、僱主推荐及操守审查等。在一般情况下，未获取录申请人的个人资料，教育局将于其落选日期后24个月全部销毁。",
        },
        {
            text: "你可以一份网上申请书申请多份教育局同时招聘的职位空缺。",
        },
        {
            text: "如你持有学府或专业团体所颁授的学历及／或专业资格，请于填妥网上申请表后，在教育局规定的截止申请日期或之前向教育局上载相关文凭／证书、成绩单及列明有关资历的授课形式（例如全日制／兼读制、在当地院校授课／遥距授课等）的证明文件副本。为了方便进行学历评审的工作，如你在取得上述的资历前已获取其他资历，亦应尽可能就该等其他资历提供证明文件副本。",
        },
        {
            text: "如你未能在进入系统后<b>2小时内</b>完成整份申请书，可使用「储存」键，把已填写的部分存档。日后当你以电邮地址或「智方便」登入系统后，便能检视已存档的资料并继续填写申请书。电邮地址已连结到已存档的资料，因此不能更改。",
        },
        {
            text: "你可于职位<b>截止申请日期前或之前</b>，使用你的电邮地址或「智方便」登入系统，以查询或更改你在申请书资料内所提交的资料，或递交补充资料。",
        },
        {
            text: "当申请人在步骤8按「下一步」后，系统会把你递交的资料再度显示在萤幕上。请覆核资料及列印一份作个人参考，其后请再按「递交」，以完成申请程序。",
        },
        {
            text: "职位截止申请后，有关的网上招聘广告将被移除。请保留你所申请每份职位的招聘广告副本一份，以备日后参考。",
        },
        {
            text: "教育局可能会以你于申请书中所提供的电邮地址作联络之用及／或（如认为合适）向该电邮地址发出聘书。你应经常及定期查阅你的电邮帐户（包括垃圾邮件箱、群发邮件箱及杂件邮箱）。如你未能及时依照教育局发出的电邮指示行事，你的申请书将不获受理或任何已发出的聘书将自动失效。",
        },
        {
            text: "如有以下情况，请与教育局聘用及人事组联络：",
        },
    ],
    contactEDBInfo: {
        info1: "未有在递交整份网上申请书后2小时内接获确认申请通知的电邮；",
        info2: "递交网上申请书后，本申请书内所提供的资料（包括你的香港特别行政区永久性居民的身分）有任何更改；",
        info3: "递交申请书后，你需要更改或查询个人资料；或",
        info4: "查询与招聘有关的事宜。",
    },
    contactInfo: {
        title: "<sup>♯</sup>教育局聘用及人事组联络资料如下:",
        post: "<u>申请职位</u>",
        tel: "<u>联络电话</u>",
        postOne:
            "助理教育主任(行政)／一级专责教育主任／二级专责教育主任／言语治疗主任",
        telOne: "2892 6177",
        postTwo: "",
        postThree: "助理督学（学位）",
        telThree: "2892 6175",
        postFour: "助理教育主任",
        telFour: "2892 5958",
        postFive: "助理小学学位教师",
        telFive: "2892 5978",
    },
    label: {
        addJob: "增加职位",
        jobPeriodStart: "开始时间",
        jobPeriodEnd: "结束时间",
        jobTitle: "职位",
        publish: "发布",
        subject: "科目",
        english: "Eng(LPA)",
        otherEnglish: "Eng(Others)",
        math: "Maths",
        putonghua: "PTH(LPA)",
        supplementary: "补充资料",
        dailyStatistics: "Daily Statistics for Reviewers",
        name: "姓名",
        userName: "用户名称",
        email: "电邮地址",
        title: "称谓",
        englishSurname: "英文姓名（姓氏）",
        englishOtherName: "英文姓名（名字）",
        chineseName: "中文姓名",
        chineseNameCode: "中文姓名电码",
        dateBirth: "出生日期",
        sexCode: "性别",
        hkidCardNo: "香港身份证号码",
        hkCardNumText: "（本栏供没有香港身份证的申请人塡写）",
        passport: "护照/ 旅行证件号码",
        issuingAuthority: "签发机关",
        permanentResident: "你是否香港特别行政区永久性居民?",
        residentialAddress: "住址",
        Room: "单位/室",
        Floor: "楼层",
        Block: "座/大厦",
        Estate: "屋邨",
        Road: "道/街",
        District: "分区",
        Country: "国家 / 地区",
        correspondenceAddress: "通讯地址 ",
        correspondenceAddressText: "（如与上址不同）",
        contactNum1: "流动电话",
        contactNum2: "住所电话",
        applicantEmail: "电邮地址",
        reEnterEmail: "请再次输入电邮地址以作确认",
        residenceText: "在香港居留时间(请按日期先后填写)",
        residenceFrom: "由",
        residenceTo: "至",
        residenceDuration: "期间(年-月)",
        residenceTotal: "合计",
        automaticCalculation: "自动计算",
        bachelorDegree: "学士学位",
        programmeName: "课程名称",
        institute: "院校",
        attendanceMode: "上课形式",
        programmeDuration: "修读年期 (年) (例如: 3)",
        programmeDurationLabel: " (例如: 3)",
        awardYear: "颁发/将获颁发的日期",
        majorSubject: "主修科目",
        minorSubject: "副修科目",
        masterOfPostGraduateStudies: "硕士/博士学位或深造课程",
        otherSpecify: "请注明",
        teacherTraining: "教师培训",
        professionalQualifications: "专业及其他资格(例如副学士、高级文凭等)",
        qualifications: "资格",
        issuingAuthorityOrInstitute: "颁发机构/院校名称",
        levelAttained: "已达到/将达到的程度",
        dateObtained: "获取/将获取资格的日期",
        otherInformation: "义务工作(按日期顺序列出)",
        nameOfAgency: "机构名称",
        positionHeld: "职位",
        workFrom: "由",
        workTo: "至",
        candidate: "你是否残疾人士?",
        natureAndDegree: "如为残疾人士，请注明残疾性质及程度",
        labelOne: "请注明在参加考试/面试时，是否需要特别的安排",
        examination: "考试",
        examinationRequired: "如需特别考试安排，请列明有关要求",
        interview: "面试",
        interviewRequired: "如需特别面试安排，请列明有关要求",
        documentNoteList: {
            1: "为了方便进行学历评审的工作，申请人应在<span class='closing-date'>申请截止日期或之前</span>上载下列证明文件，并尽可能提供所有其他有关学历证明文件 -",
            2: "1.学士/硕士/博士学位证书及成绩单",
            3: "2.教师培训证书及成绩单",
            4: "3.其他(例如: 改名契等)",
        },
        documentNote:
            "备注:<br/>i)  每次上传最多五(5)个档案。上传档案的总上限为10MB。<br/>ii) 请确保各上传档案清晰可读，档案格式应为JPEG，PDF，GIF或PNG。<br/>iii) 如有需要，申请人其后或须提交其他证明文件，以便本局评审其学历资格。<br/>iv) 请不要上传设有密码保护的档案。",
        informationNote:
            "注：政府在遴选时对残疾人士及其他申请人会一视同仁。申请人如需获得为残疾人士而设的聘任相关安排，教育局可能要求提交医生证明其为残疾人士。",
        declarationList: {
            1: "本人确认符合职位列明所需的入职要求，并已上载/将会在截止申请日期或之前上载招聘广告列明所需提交的证明文件。",
            2: "本人明白倘若故意在填写本申请书时虚报资料或隐瞒重要事实，或未有在申请书内所提供资料已作更改后通知教育局，可令本人丧失获政府录用的资格；即使已获政府录用，亦可遭终止聘用。",
            3: "本人同意政府可就进行与政府招聘工作及僱用有关的事宜，及为核实上述资料而进行必要的查询。本人授权所有政府部门及其他组织或机构可就这些查询，透露任何有关的纪录及资料（其中包括，在提出聘任前，向本人的现行及／或前僱主索取一份僱主推荐书／工作表现评核报告；向有关当局／机构／医护人员索取本人的体格检查报告、医事委员会报告或诊疗纪录，及将有关资料送交其他当局／机构／医护人员；以及向有关的政府部门／院校／机构查询本人的学历／语文／专业资格和索取有关纪录，及将有关资料送交其他政府部门／当局／机构进行学历评审）。本人谨此授权香港警务处处长或其代表把所有关于我的犯罪纪录及详情发放予有关政府部门／当局／机构。就我的职位申请，我也同意当有需要时，可套取我的指纹以核实我的犯罪纪录。",
            4: "本人明白并同意，如有需要，上述资料会送交获授权处理有关资料的政府部门及其他组织或机构，用以进行与政府招聘工作，以及其他与僱用和人力资源管理有关的事宜，例如学历评审、体格检查、僱主推荐及操守审查等。",
        },
        declarationNote:
            "注： 请在下列所有方格内加上 “✓” 号，表示你已阅读，明白及接受此部所列明之所有条件，否则你的申请将不获处理。",
        agreement: "本人已閱讀、明白及接受上述之條件及細則。",
        bestResultsInCNSubject: "中文科最佳成绩",
        secondaryEducationExamination: "(i) 香港中学文凭考试",
        secondaryEducationExaminationofEn: "(i) 香港中学文凭考试 - 英国语文",
        secondaryEducationExaminationofCn: "(i) 香港中学文凭考试- 中国语文",
        advancedLevelExamination: "(ii) 香港高级程度会考",
        advancedLevelExaminationofEn: "(ii) 香港高级程度会考 – 英语运用",
        advancedLevelExaminationofCn:
            "(ii) 香港高级程度会考 – 中国语文、中国语言文学或中国语文及文化",
        cnCulture: "中国语文及文化",
        cnLiterature: "中国语文、中国语言文学",
        CRE: "(iii) 综合招聘考试 - 中文运用",
        level: "等级",
        testDate: "测试日期",
        selectPlaceHolder: "请选择一个选项",
        bestResultsInENSubject: "英文科最佳成绩",
        CREofEn: "(v) 综合招聘考试 - 英文运用",
        IELTS: "(iii) 国际英语水平测试 (IELTS) (学术模式)",
        overallBand: "整体分级",
        listeningBand: "听解分级",
        readingBand: "阅读分级",
        writingBand: "写作分级",
        speakingBand: "英语会话分级",
        testDateofEn: "考试日期",
        advancedLevel: "(iv) 普通教育高级程度证书 - 英国语文",
        nationalSecurityResult: "基本法及香港国安法测试",
        nationalSecurityResultMsg:
            "(《基本法》测试的成绩并不等同《基本法及香港国安法》测试的成绩）",
        nationalSecurityResultNote:
            "（注：由2023年7月28日起展开招聘的公务员职位，申请人可以参加公务员事务局、教育局或各招聘部门／职系举办的《基本法及香港国安法》测试。无论测试是在2023年7月28日之前或之后举行，及格成绩可以互通，用作申请相关公务员职位，以及公帑资助学校或参加幼稚园教育计划的幼稚园教席。）",
        nationalSecurityResultTitle:
            "你是否曾于下列测试中取得及格成绩？ （请选择适用答案。如你未曾参加以下任何一项测试，请选择“不适用”。）",
        result: "(a) 基本法及香港国安法测试(学位／专业程度职系) (由公务员事务局或各招聘部门／职系举办)",
        nationalSecurityResultLevel:
            "(b) 基本法及香港国安法测试(学位程度) (由教育局举办)",
        languageCommission: "国家语言文字工作委员会 – 普通话水平测试",
        grade: "级别",
        AEOorAPSMSupplementary: "英国语文科补充资料",
        englishLanguage: "英国语文",
        LPATEnglish: "(i) 语文能力评核（前称「教师语文能力评核」）(英国语文) ",
        reading: "阅读",
        writing: "写作",
        listening: "聆听",
        speaking: "口语",
        classroomAssessment: "课堂语言运用",
        levelAttainedofEnglish: "已达到的级别",
        obtainedDate: "获取/豁免日期",
        AEOSupplementary: "助理教育主任(英国语文)职位补充资料",
        GCEExaminations:
            "(ii) 英国伦敦普通教育文凭考试／英国普通教育文凭考试(普通程度)(海外)（GCE ‘O’ Level Overseas）",
        obtainedDateOfMY: "获取日期",
        IGCSEForEnglish:
            "(iii) 英国剑桥大学普通教育文凭考试（IGCSE）英文科(作为第一语言／第二语言)",
        instituteMembership: "(iv) 英国语言学会会员资格",
        othersSpecify: "其他，请注明",
        MathSupplementary: "数学科补充资料",
        compulsoryPart: "必修部分",
        calculusStatistics: "延伸部分 - 单元一（微积分与统计）",
        algebraCalculus: "延伸部分 - 单元二（代数与微积分）",
        hkCertificateOfExamination: "(iii) 香港中学会考",
        year2006OrBefore: "2006 年或以前",
        year2007OrBefore: "2007 年或以后",
        PutonghuaSupplementary: "普通话科补充资料",
        LPATPutonghua: "(i) 语文能力评核（前称「教师语文能力评核」）(普通话)",
        AttainedLevel3: "成绩达到「三级」或以上",
        workingExperience:
            "截至目前为止的全部就业详情（包括以前受僱于政府的资料和兼职资料）（按任职的日期顺序列出）",
        schoolName: "学校/机构名称",
        fullTimeOrPartTime: "全职/兼职",
        natureWork: "工作性质",
        subjectTaught: "任教科目",
        levelTaught: "任教年级",
        periodOfdmy: "期间",
        employmentDuration: "全职工作时间",
        dutiesDescription: "职责说明（例如：课堂教学、拟备试卷等）",
        fullTimeEmployment: "全职工作年数",
        disciplinaryOffence:
            "如你现时或曾在政府任职，在政府任职期间曾否有任何违反纪律的纪录？",
        disciplinaryOffenceDetails: "如有， 请列明详情",
        disciplinaryOffenceNote:
            "(注:如申请人曾有违反纪律纪录，政府不一定因此而不予录用。)",
        workingExperienceFrom: "由",
        workingExperienceTo: "至",
        postTitle: "请选择你想申请的职位<span class='danger'>*</span>",
        period: "日期",
        otherInformationTitle: "其他资讯 (可选择是否填写)",
        type: "类别",
        validityDate: "有效期",
        creTestDate: "考试日期",
        equivalentLevel2: "等同二级成绩",
        bestResultCnMsg:
            "请注意，你并未符合相关职位的语文能力要求(即在综合招聘考试的中文运用试卷中取得“二级”成绩，或具备同等成绩)，申请将不获继续处理。如欲了解相关职位的语文能力要求，请参阅招聘广告。如有查询，请在办公时间内致电2892 6686与教育局聘用及人事组联络，或电邮至 edbappt@edb.gov.hk。",
        bestResultEnMsg:
            "请注意，你并未符合相关职位的语文能力要求(即在综合招聘考试的英文运用试卷中取得“二级”成绩，或具备同等成绩)，申请将不获继续处理。如欲了解相关职位的语文能力要求，请参阅招聘广告。如有查询，请在办公时间内致电2892 6686与教育局聘用及人事组联络，或电邮至 edbappt@edb.gov.hk。",
        bestResultEnAndCnMsg:
            "请注意，你并未符合相关职位的语文能力要求(即在综合招聘考试的中文运用及英文运用试卷中取得“二级”成绩，或具备同等成绩)，申请将不获继续处理。如欲了解相关职位的语文能力要求，请参阅招聘广告。如有查询，请在办公时间内致电2892 6686与教育局聘用及人事组联络，或电邮至 edbappt@edb.gov.hk。",
        notedContinue: "明白及继续",
        guiltyOffence: "你曾否经香港或香港以外的法庭判定有罪？",
        guiltyOffenceDetails: "如经判定有罪，请列明详情",
        servingServed: "你是否现时或曾在政府任职?",
        servingServedYesMsg:
            "如你现时或曾在政府任职，你曾否签署声明，拥护《中华人民共和国香港特别行政区基本法》，效忠中华人民共和国香港特别行政区（“香港特区”），尽忠职守和对香港特区政府负责？",
        noneOption: "请选择",
        importantNotes: "本人确认已阅读并完全理解上述重要须知。",
        noted: "明白",
        timeoutNote:
            "注：你的申请将在登入超过2小时及／或系统閒置超过30分钟后自动关闭。",
        timeoutMsg:
            "你的申请将在{{minutes}}分钟后自动关闭。请谨记在登出前完成/储存你的申请。",
        supplementaryInfo: "补充资料",
        guiltyOffenceNote:
            "（注：请参阅《罪犯自新条例》(第297章) (该条例)。请特别留意该条例第4(2)(c)条及附表所载的例外规定。该条例第4(2)(c)条规定，第2(1)及(1A)条给予已自新人士的保障，并不适用于与订明职位的聘任有关的问题。订明职位列于该条例附表内，包括“正由或将由薪俸在总薪级表第27薪点或以上的人员出任的职位”。举例说，如你正申请总薪级表第25至33薪点的职位，因这个职位将由薪俸在总薪级表第27薪点或以上的人员出任，所以第2(1)及(1A)条给予已自新人士的保障并不适用，你必须对曾被判有罪行的所有罪行（如有的话）作出声明，否则将不获考虑聘任。如你对申请职位的薪级表有疑问，请向教育局查询。）",
        servingServedNote:
            "（注： 所有中华人民共和国香港特别行政区政府（“香港特区政府 ”）的公务员及按非公务员聘用条款聘用的政府僱员均须签署声明， 拥护 《中华人民共和国香港特别行政区基本法》， 效忠中华人民共和国香港特别行政区 ， 尽忠职守和对香港特区政府负责。）",
        employmentNote: "（注：申请人的相关工作经验及性质将作进一步审核。）",
        permanentResidentNote:
            "请注意除另有指明外，申请人于<b>获聘时</b>必须已成为香港特别行政区永久性居民。",
        permanentResidentMsg:
            "（如对香港特别行政区永久性居民身分有任何疑问，可致电入境事务处居留权查询热线2824 6111。）",
        previewPDF:
            "如你想打印及/或下载 PDF 格式的申请表，请按下方「预览 PDF」键。",
        LPATEnglishNote:
            "请注意，除另有指明外，你在获聘时必须在语文能力评核（前称「教师语文能力评核」）（英国语文）达到「三级」或以上的成绩，或已获豁免符合该项语文能力要求。",
        LPATPutonghuaNote:
            "请注意，除另有指明外，你在获聘时必须在语文能力评核（前称「教师语文能力评核」）（普通话）达到「三级」或以上的成绩。",
        AEOAandAIG4yearsNote:
            "请注意，你并未符合助理督学(学位)职位的工作经验要求，申请将不获继续处理。你可考虑修改申请书内的资料。如欲了解相关职位的工作经验要求，请参阅招聘广告。如有查询，请在办公时间内致电2892 6686与教育局聘用及人事组联络，或电邮至 edbappt@edb.gov.hk。",
        SES14yearsNote:
            "请注意，你并未符合申请一级专责教育主任职位的工作经验要求。你的申请将不能作进一步处理。你可重新修订申请书内申请职位及/或其他资料。有关申请职位的工作经验要求，请参阅招聘广告。如有任何查询，请在正常办公时间内致电2892 6686与教育局聘用及人事组联络或电邮致 edbappt@edb.gov.hk",
        AEOAandorAIG3yearsNote:
            "请注意，你并未符合相关职位的工作经验要求，申请将不获继续处理。你可考虑修改申请书内的资料。如欲了解相关职位的工作经验要求，请参阅招聘广告。如有查询，请在办公时间内致电2892 6686与教育局聘用及人事组联络，或电邮至 edbappt@edb.gov.hk。",
        AIG4yearsNote:
            "请注意，你并未符合相关职位的工作经验要求，申请将不获继续处理。你可考虑修改申请书内的资料。如欲了解相关职位的工作经验要求，请参阅招聘广告。如有查询，请在办公时间内致电2892 6686与教育局聘用及人事组联络，或电邮至 edbappt@edb.gov.hk。",
        placeOfBirth: "出生地点",
        postSelectNote: "注：你可在本申请书选择多个职位。",
        autosuggestGroupText: "请选择及/或输入文字",
        professionalMsgForSE:
            "就助理督学(学位)(特殊教育)职位︰请在「专业及其他资格」一栏内述明曾接受的特殊教育相关训练。",
        workingExperienceMsgForSE:
            "就助理督学(学位)(特殊教育)职位︰请在「职责说明」一栏内阐述在取得学士学位后是否具备四年相关工作经验，如教育及／或支援有特殊教育需要的学童，及／或具备特殊学校教学经验，或其他同等经验。请提供有关细节，包括但不限于任教的学校/服务的机构、职位、任教/服务年级及任教/服务年期。",
        workingExperienceMsgForKindergarten:
            "就助理督学(学位)(幼稚园教育)职位︰请在「职责说明」一栏内阐述在取得学士学位后是否具备四年从事幼儿教育或幼儿工作的相关经验。请提供有关细节，包括但不限于任教的学校/服务的机构、职位、任教/服务年级及任教/服务年期。",
        workingExperienceMsgForCounselling:
            "就助理督学(学位)(教育辅导、学生辅导及训育)职位︰请在「职责说明」一栏内阐述在取得学士学位后是否具备四年从事儿童教育、训育或辅导的相关工作经验。请提供有关细节，包括但不限于任教的学校/服务的机构、职位、任教/服务年级及任教/服务年期。",
        workingExperienceMsgForCitizenship:
            "就助理督学(学位)(公民与社会发展)职位︰请在「职责说明」一栏内阐述在取得学士学位后是否具备四年相关工作经验，当中并包括最少三年全面涵盖中四、中五及中六通识教育学科的教学经验。请提供有关细节，包括但不限于任教的学校/机构、职位、任教年级及任教年期。",
        specialEducation: "特殊教育",
        nonSpecialEducation: "非特殊教育",
        computerSystemConfiguration: "电脑系统配置",
        computerSystemConfigurationText1:
            "为确保本系统能正确及有效地为你提供服务，我们建议你使用最新版本的<b>微软Edge、Mozilla Firefox、Safari或Google Chrome浏览器</b>，以获最佳效果。",
        computerSystemConfigurationText2:
            "教育局不会就任何因操作系统及互联网浏览器组合所引致的系统故障及有关职位查询／申请的错误、遗漏、延误、或错误陈述或失实陈述（不论明示或默示的）承担任何责任。",
        iamsmartContent:
            "你可选择以「智方便填表通」的个人资料自动填写网上表格。请点选「智方便填表通」。",
        append: "加行",
        fileUploadMsg: "选择档案",
        switchLangContent:
            "转换语言后，网页会转至申请书首页，已填写的资料将不会转移至申请书。",
        switchLangContent2: "请确认是否仍须转换语言。",
        successfulSubmissionMsg1: "你已成功递交申请书。",
        successfulSubmissionMsg2: "系统已发送确认电邮至你的电邮地址。",
        servedEDBNote: "你是否现时或曾在教育局任职？",
        servedSchoolNote: "你现时或曾在哪间官立学校/教育局分部及/或组别任职？",
        schoolOrDivision: "学校/分部/组别",
        fromDate: "由",
        toDate: "至",
        englishBestResultsNote:
            "(注：如你申请助理教育主任 / 助理小学学位教师（英国语文），请在下方填写你的国际英语水平测试（学术模式）成绩(如适用)。)",
        englishSupplementaryNote:
            "(注：请在下方填写语文能力评核成绩及/或在第4.3步填写国际英语水平测试（学术模式）成绩。)",
    },
    options: {
        titleOp: {
            Dr: "博士",
            Miss: "小姐",
            Mr: "先生",
            Mrs: "太太",
            Ms: "女士",
        },
        sexCodeOp: {
            M: "男性",
            F: "女性",
        },
        permanentResidentOp: {
            Yes: "是",
            No: "否",
        },
        districtOldOp: {
            CW: "中西区",
            HKE: "东区",
            SOU: "南区",
            I: "离岛",
            WCH: "湾仔",
            KC: "九龙城",
            KT: "观塘",
            SSP: "深水埗",
            WTS: "黄大仙",
            YTM: "油尖旺",
            KWT: "葵青",
            TW: "荃湾",
            YL: "元朗",
            TM: "屯门",
            N: "北区",
            SK: "西贡",
            ST: "沙田",
            TP: "大埔",
        },
        districtOp: {
            中西区: {
                Admiralty: "金钟",
                Central: "中环",
                "Kennedy Town": "坚尼地城",
                "Mid-levels": "半山",
                "Sheung Wan": "上环",
                "Shek Tong Tsui": "石塘咀",
                "Sai Ying Pun": "西营盘",
                "The Peak": "山顶",
                "West Point": "西环",
            },
            东区: {
                "Braemar Hill": "宝马山",
                "Chai Wan": "柴湾",
                "Fortress Hill": "炮台山",
                "Heng Fa Chuen": "杏花邨",
                "North Point": "北角",
                "Quarry Bay": "鰂鱼涌",
                "Shau Kei Wan": "筲箕湾",
                "Siu Sai Wan": "小西湾",
                "Sai Wan Ho": "西湾河",
                "Tin Hau": "天后",
                "Tai Koo": "太古",
            },
            南区: {
                Aberdeen: "香港仔",
                "Ap Lei Chau": "鸭脷洲",
                "Chung Hom Kok": "舂磡角",
                "Deep Water Bay": "深水湾",
                "Pok Fu Lam": "薄扶林",
                "Repulse Bay": "浅水湾",
                "Shouson Hill": "寿臣山",
                "Shek O": "石澳",
                Stanley: "赤柱",
                "Tai Tam": "大潭",
                "Tin Wan": "田湾",
                "Wong Chuk Hang": "黄竹坑",
                "Wong Nai Chung": "黄泥涌",
            },
            湾仔区: {
                "Causeway Bay": "铜锣湾",
                "Happy Valley": "跑马地",
                "So Kon Po": "扫杆埔",
                "Tai Hang": "大坑",
                "Wan Chai": "湾仔",
            },
            九龙城区: {
                "Ho Man Tin": "何文田",
                "Hung Hom": "红磡",
                "Kowloon City": "九龙城",
                "Kowloon Tong": "九龙塘",
                "Kai Tak": "启德",
                "Ma Tau Chung": "马头涌",
                "Ma Tau Wai": "马头围",
                "To Kwa Wan": "土瓜湾",
                Whampoa: "黄埔",
            },
            观塘区: {
                "Cha Kwo Ling": "茶果岭",
                "Kowloon Bay": "九龙湾",
                "Kwun Tong": "观塘",
                "Lam Tin": "蓝田",
                "Lei Yue Mun": "鲤鱼门",
                "Ngau Tau Kok": "牛头角",
                "Sau Mau Ping": "秀茂坪",
                "Yau Tong": "油塘",
            },
            深水埗区: {
                "Cheung Sha Wan": "长沙湾",
                "Lai Chi Kok": "荔枝角",
                "Mei Foo": "美孚",
                "Nam Cheong": "南昌",
                "Stonecutters Island": "昂船洲",
                "Shek Kip Mei": "石硖尾",
                "Sham Shui Po": "深水埗",
                "Tai Kok Tsui": "大角咀",
                "Tai Wo Ping": "大窝坪",
                "Yau Yat Tsuen": "又一村",
            },
            黄大仙区: {
                "Choi Hung": "彩虹",
                "Diamond Hill": "鑽石山",
                "Lok Fu": "乐富",
                "Ngau Chi Wan": "牛池湾",
                "San Po Kong": "新蒲岗",
                "Tsz Wan Shan": "慈云山",
                "Wang Tau Hom": "横头磡",
                "Wong Tai Sin": "黄大仙",
            },
            油尖旺区: {
                "Ferry Point": "渡船角",
                Jordan: "佐敦",
                "Mong Kok": "旺角",
                "Prince Edward": "太子",
                "Tsim Sha Tsui": "尖沙咀",
                "West Kowloon": "西九龙",
                "Yau Ma Tei": "油麻地",
            },
            离岛区: {
                "Cheung Chau": "长洲",
                "Cheung Sha Lantau Island": "大屿山长沙",
                "Chek Lap Kok Lantau Island": "大屿山赤鱲角",
                "Chi Ma Wan Lantau Island": "大屿山芝蔴湾",
                "Discovery Bay Lantau Island": "大屿山愉景湾",
                Disneyland: "迪士尼乐园",
                "Disneyland Resort": "迪士尼度假区",
                "Hei Ling Chau": "喜灵洲",
                "Lantau Island": "大屿山",
                "Lamma Island": "南丫岛",
                "Mui Wo Lantau Island": "大屿山梅窝",
                "Ngong Ping Lantau Island": "大屿山昂坪",
                "Peng Chau": "坪洲",
                "Poi Toi Island": "蒲台岛",
                "Shek Pik Lantau Island": "大屿山石壁",
                "Shek Kwu Chau": "石鼓洲",
                "Sha Lo Wan": "沙螺湾",
                "Tai O Lantau Island": "大屿山大澳",
                "Tong Fuk Lantau Island": "大屿山塘福",
                "Tung Peng Chau": "东平洲",
                "Tung Chung Lantau Island": "大屿山东涌",
            },
            葵青区: {
                "Kwai Fong": "葵芳",
                "Kwai Hing": "葵兴",
                "Kwai Shing": "葵盛",
                "Kwai Chung": "葵涌",
                "Lai King": "荔景",
                "Shek Lei": "石篱",
                "Tsing Yi": "青衣",
                "Tai Wo Hau": "大窝口",
            },
            北区: {
                "Crooked Island": "吉澳洲",
                Fanling: "粉岭",
                "Hang Tau": "坑头",
                "Kat O": "吉澳",
                "Kwu Tung": "古洞",
                "Lo Wu": "罗湖",
                "Luen Wo Hui": "联和墟",
                "Lung Yeuk Tau": "龙跃头",
                "Man Kam To": "文锦渡",
                "Muk Wu": "木湖",
                "Ping Che": "坪輋",
                "Sheung Shui": "上水",
                "Sandy Ridge": "沙岭",
                "Sha Tau Kok": "沙头角",
                "Shek Wu Hui": "石湖墟",
                "Tsiu Hang": "蕉坑",
                "Ta Kwu Ling": "打鼓岭",
                "Wong Kong Shan": "黄岗山",
            },
            西贡区: {
                "Clear Water Bay": "清水湾",
                "Fei Ngo Shan": "飞鹅山",
                "Hang Hau Sai Kung": "西贡坑口",
                "Kau Sai Chau": "滘西洲",
                "Lohas Park": "康城",
                "Leung Shuen Wan": "粮船湾",
                "Po Lam": "宝林",
                "Po Lo Che": "菠萝輋",
                "Pak Shek Wo": "白石窝",
                "Pak Sha Wan": "白沙湾",
                "Pak Tam Chung": "北潭涌",
                "Pik Uk": "壁屋",
                "Sai Kung": "西贡",
                "Sha Kok Mei": "沙角尾",
                "Tiu Keng Leng": "调景岭",
                "Tseung Kwan O": "将军澳",
                "Tung Lung Chau": "东龙洲",
                "Tui Min Hoi": "对面海",
            },
            沙田区: {
                "A Kung Kok": "亚公角",
                "Che Kung Miu": "车公庙",
                "Fo Tan Sha Tin": "沙田火炭",
                "Hin Keng": "显径",
                "Heng On": "恆安",
                "Kau To Shan": "九肚山",
                "Ma Liu Shui": "马料水",
                "Ma On Shan": "马鞍山",
                "Pak Shek Kok": "白石角",
                "Sha Tin": "沙田",
                "Siu Lek Yuen Sha Tin": "沙田小沥源",
                "Shek Mun": "石门",
                "Sha Tin Wai": "沙田围",
                "Sui Wo": "穗禾",
                "Tai Wai Sha Tin": "沙田大围",
                "Wu Kai Sha": "乌溪沙",
            },
            屯门区: {
                "Castle Peak Bay": "青山湾",
                "Fu Tei Tuen Mun": "屯门虎地",
                "Kau Hui": "旧墟",
                "Lung Kwu Tan": "龙鼓滩",
                "Lam Tei Tuen Mun": "屯门蓝地",
                "San Hui Tuen Mun": "屯门新墟",
                "Siu Lam Tuen Mun": "屯门小榄",
                "So Kwun Wat": "扫管笏",
                "Tai Lam": "大榄",
                "Tuen Mun": "屯门",
            },
            大埔区: {
                "Cheung Muk Tau": "樟木头",
                "Kau Lung Hang": "九龙坑",
                "Lam Tsuen Tai Po": "大埔林村",
                "Lam Tsuen Valley": "林村谷",
                "Nam Hang": "南坑",
                "Shap Sze Heung": "十四乡",
                "Shuen Wan Tai Po": "大埔船湾",
                "Tai Po": "大埔",
                "Tai Wo": "太和",
                "Tap Mun": "塔门",
                "Tai Mei Tuk": "大美督",
                "Tai Po Kau": "大埔滘",
                "Tai Po Market": "大埔墟",
                "Tai Po Tau": "大埔头",
                "Yuen Chau Tsai": "元洲仔",
            },
            荃湾区: {
                "Lei Muk Shue": "梨木树",
                "Lo Wai Tsuen Wan": "荃湾老围",
                "Ma Wan": "马湾",
                "Sunny Bay": "欣澳",
                "Sham Tseng": "深井",
                "Ting Kau": "汀九",
                "Tsing Lung Tau": "青龙头",
                "Tsuen Wan": "荃湾",
            },
            元朗区: {
                "Au Tau": "坳头",
                "Ha Tsuen Yuen Long": "元朗厦村",
                "Hung Shui Kiu": "洪水桥",
                "Kam Tin Yuen Long": "元朗锦田",
                "Lau Fau Shan": "流浮山",
                "Lok Ma Chau": "落马洲",
                "Long Ping": "朗屏",
                "Ma Tin": "马田",
                "Pat Heung Yuen Long": "元朗八乡",
                "Ping Shan Yuen Long": "元朗屏山",
                "San Tin Yuen Long": "元朗新田",
                "Shek Kong Yuen Long": "元朗石岗",
                "Shap Pat Heung": "十八乡",
                "Tam Mei Yuen Long": "元朗潭尾",
                "Tin Shui Wai": "天水围",
                "Tai Shu Ha": "大树下",
                "Tai Sang Wai": "大生围",
                "Tai Tong Yuen Long": "元朗大棠",
                "Wang Chau": "横洲",
                "Wang Toi Shan": "横台山",
                "Yuen Long": "元朗",
            },
        },
        districtTcOp: {
            中西區: {
                Admiralty: "金鐘",
                Central: "中環",
                "Kennedy Town": "堅尼地城",
                "Mid-levels": "半山",
                "Sheung Wan": "上環",
                "Shek Tong Tsui": "石塘咀",
                "Sai Ying Pun": "西營盤",
                "The Peak": "山頂",
                "West Point": "西環",
            },
            東區: {
                "Braemar Hill": "寶馬山",
                "Chai Wan": "柴灣",
                "Fortress Hill": "炮台山",
                "Heng Fa Chuen": "杏花邨",
                "North Point": "北角",
                "Quarry Bay": "鰂魚涌",
                "Shau Kei Wan": "筲箕灣",
                "Siu Sai Wan": "小西灣",
                "Sai Wan Ho": "西灣河",
                "Tin Hau": "天后",
                "Tai Koo": "太古",
            },
            南區: {
                Aberdeen: "香港仔",
                "Ap Lei Chau": "鴨脷洲",
                "Chung Hom Kok": "舂磡角",
                "Deep Water Bay": "深水灣",
                "Pok Fu Lam": "薄扶林",
                "Repulse Bay": "淺水灣",
                "Shouson Hill": "壽臣山",
                "Shek O": "石澳",
                Stanley: "赤柱",
                "Tai Tam": "大潭",
                "Tin Wan": "田灣",
                "Wong Chuk Hang": "黃竹坑",
                "Wong Nai Chung": "黃泥涌",
            },
            灣仔區: {
                "Causeway Bay": "銅鑼灣",
                "Happy Valley": "跑馬地",
                "So Kon Po": "掃桿埔",
                "Tai Hang": "大坑",
                "Wan Chai": "灣仔",
            },
            九龍城區: {
                "Ho Man Tin": "何文田",
                "Hung Hom": "紅磡",
                "Kowloon City": "九龍城",
                "Kowloon Tong": "九龍塘",
                "Kai Tak": "啟德",
                "Ma Tau Chung": "馬頭涌",
                "Ma Tau Wai": "馬頭圍",
                "To Kwa Wan": "土瓜灣",
                Whampoa: "黃埔",
            },
            觀塘區: {
                "Cha Kwo Ling": "茶果嶺",
                "Kowloon Bay": "九龍灣",
                "Kwun Tong": "觀塘",
                "Lam Tin": "藍田",
                "Lei Yue Mun": "鯉魚門",
                "Ngau Tau Kok": "牛頭角",
                "Sau Mau Ping": "秀茂坪",
                "Yau Tong": "油塘",
            },
            深水埗區: {
                "Cheung Sha Wan": "長沙灣",
                "Lai Chi Kok": "荔枝角",
                "Mei Foo": "美孚",
                "Nam Cheong": "南昌",
                "Stonecutters Island": "昂船洲",
                "Shek Kip Mei": "石硤尾",
                "Sham Shui Po": "深水埗",
                "Tai Kok Tsui": "大角咀",
                "Tai Wo Ping": "大窩坪",
                "Yau Yat Tsuen": "又一村",
            },
            黃大仙區: {
                "Choi Hung": "彩虹",
                "Diamond Hill": "鑽石山",
                "Lok Fu": "樂富",
                "Ngau Chi Wan": "牛池灣",
                "San Po Kong": "新蒲崗",
                "Tsz Wan Shan": "慈雲山",
                "Wang Tau Hom": "橫頭磡",
                "Wong Tai Sin": "黃大仙",
            },
            油尖旺區: {
                "Ferry Point": "渡船角",
                Jordan: "佐敦",
                "Mong Kok": "旺角",
                "Prince Edward": "太子",
                "Tsim Sha Tsui": "尖沙咀",
                "West Kowloon": "西九龍",
                "Yau Ma Tei": "油麻地",
            },
            離島區: {
                "Cheung Chau": "長洲",
                "Cheung Sha Lantau Island": "大嶼山長沙",
                "Chek Lap Kok Lantau Island": "大嶼山赤鱲角",
                "Chi Ma Wan Lantau Island": "大嶼山芝蔴灣",
                "Discovery Bay Lantau Island": "大嶼山愉景灣",
                Disneyland: "迪士尼樂園",
                "Disneyland Resort": "迪士尼度假區",
                "Hei Ling Chau": "喜靈洲",
                "Lantau Island": "大嶼山",
                "Lamma Island": "南丫島",
                "Mui Wo Lantau Island": "大嶼山梅窩",
                "Ngong Ping Lantau Island": "大嶼山昂坪",
                "Peng Chau": "坪洲",
                "Poi Toi Island": "蒲台島",
                "Shek Pik Lantau Island": "大嶼山石壁",
                "Shek Kwu Chau": "石鼓洲",
                "Sha Lo Wan": "沙螺灣",
                "Tai O Lantau Island": "大嶼山大澳",
                "Tong Fuk Lantau Island": "大嶼山塘福",
                "Tung Peng Chau": "東平洲",
                "Tung Chung Lantau Island": "大嶼山東涌",
            },
            葵青區: {
                "Kwai Fong": "葵芳",
                "Kwai Hing": "葵興",
                "Kwai Shing": "葵盛",
                "Kwai Chung": "葵涌",
                "Lai King": "荔景",
                "Shek Lei": "石籬",
                "Tsing Yi": "青衣",
                "Tai Wo Hau": "大窩口",
            },
            北區: {
                "Crooked Island": "吉澳洲",
                Fanling: "粉嶺",
                "Hang Tau": "坑頭",
                "Kat O": "吉澳",
                "Kwu Tung": "古洞",
                "Lo Wu": "羅湖",
                "Luen Wo Hui": "聯和墟",
                "Lung Yeuk Tau": "龍躍頭",
                "Man Kam To": "文錦渡",
                "Muk Wu": "木湖",
                "Ping Che": "坪輋",
                "Sheung Shui": "上水",
                "Sandy Ridge": "沙嶺",
                "Sha Tau Kok": "沙頭角",
                "Shek Wu Hui": "石湖墟",
                "Tsiu Hang": "蕉坑",
                "Ta Kwu Ling": "打鼓嶺",
                "Wong Kong Shan": "黃崗山",
            },
            西貢區: {
                "Clear Water Bay": "清水灣",
                "Fei Ngo Shan": "飛鵝山",
                "Hang Hau Sai Kung": "西貢坑口",
                "Kau Sai Chau": "滘西洲",
                "Lohas Park": "康城",
                "Leung Shuen Wan": "糧船灣",
                "Po Lam": "寶林",
                "Po Lo Che": "菠蘿輋",
                "Pak Shek Wo": "白石窩",
                "Pak Sha Wan": "白沙灣",
                "Pak Tam Chung": "北潭涌",
                "Pik Uk": "壁屋",
                "Sai Kung": "西貢",
                "Sha Kok Mei": "沙角尾",
                "Tiu Keng Leng": "調景嶺",
                "Tseung Kwan O": "將軍澳",
                "Tung Lung Chau": "東龍洲",
                "Tui Min Hoi": "對面海",
            },
            沙田區: {
                "A Kung Kok": "亞公角",
                "Che Kung Miu": "車公廟",
                "Fo Tan Sha Tin": "沙田火炭",
                "Hin Keng": "顯徑",
                "Heng On": "恆安",
                "Kau To Shan": "九肚山",
                "Ma Liu Shui": "馬料水",
                "Ma On Shan": "馬鞍山",
                "Pak Shek Kok": "白石角",
                "Sha Tin": "沙田",
                "Siu Lek Yuen Sha Tin": "沙田小瀝源",
                "Shek Mun": "石門",
                "Sha Tin Wai": "沙田圍",
                "Sui Wo": "穗禾",
                "Tai Wai Sha Tin": "沙田大圍",
                "Wu Kai Sha": "烏溪沙",
            },
            屯門區: {
                "Castle Peak Bay": "青山灣",
                "Fu Tei Tuen Mun": "屯門虎地",
                "Kau Hui": "舊墟",
                "Lung Kwu Tan": "龍鼓灘",
                "Lam Tei Tuen Mun": "屯門藍地",
                "San Hui Tuen Mun": "屯門新墟",
                "Siu Lam Tuen Mun": "屯門小欖",
                "So Kwun Wat": "掃管笏",
                "Tai Lam": "大欖",
                "Tuen Mun": "屯門",
            },
            大埔區: {
                "Cheung Muk Tau": "樟木頭",
                "Kau Lung Hang": "九龍坑",
                "Lam Tsuen Tai Po": "大埔林村",
                "Lam Tsuen Valley": "林村谷",
                "Nam Hang": "南坑",
                "Shap Sze Heung": "十四鄉",
                "Shuen Wan Tai Po": "大埔船灣",
                "Tai Po": "大埔",
                "Tai Wo": "太和",
                "Tap Mun": "塔門",
                "Tai Mei Tuk": "大美督",
                "Tai Po Kau": "大埔滘",
                "Tai Po Market": "大埔墟",
                "Tai Po Tau": "大埔頭",
                "Yuen Chau Tsai": "元洲仔",
            },
            荃灣區: {
                "Lei Muk Shue": "梨木樹",
                "Lo Wai Tsuen Wan": "荃灣老圍",
                "Ma Wan": "馬灣",
                "Sunny Bay": "欣澳",
                "Sham Tseng": "深井",
                "Ting Kau": "汀九",
                "Tsing Lung Tau": "青龍頭",
                "Tsuen Wan": "荃灣",
            },
            元朗區: {
                "Au Tau": "坳頭",
                "Ha Tsuen Yuen Long": "元朗廈村",
                "Hung Shui Kiu": "洪水橋",
                "Kam Tin Yuen Long": "元朗錦田",
                "Lau Fau Shan": "流浮山",
                "Lok Ma Chau": "落馬洲",
                "Long Ping": "朗屏",
                "Ma Tin": "馬田",
                "Pat Heung Yuen Long": "元朗八鄉",
                "Ping Shan Yuen Long": "元朗屏山",
                "San Tin Yuen Long": "元朗新田",
                "Shek Kong Yuen Long": "元朗石崗",
                "Shap Pat Heung": "十八鄉",
                "Tam Mei Yuen Long": "元朗潭尾",
                "Tin Shui Wai": "天水圍",
                "Tai Shu Ha": "大樹下",
                "Tai Sang Wai": "大生圍",
                "Tai Tong Yuen Long": "元朗大棠",
                "Wang Chau": "橫洲",
                "Wang Toi Shan": "橫台山",
                "Yuen Long": "元朗",
            },
        },
        countryOp: {
            中国: {
                "HK-CN": "香港",
                Mainland: "內地",
                Macao: "澳门",
                Taiwan: "台湾",
            },
            其他: {
                Afghanistan: "阿富汗",
                "Aland-Islands": "奥兰群岛",
                Albania: "阿尔巴尼亚",
                Algeria: "阿尔及利亚",
                "American-Siamoa": "美属萨摩亚",
                Andorra: "安道尔",
                Angola: "安哥拉",
                Anguilla: "安圭拉",
                Antarctica: "南极洲",
                "Antigua-Barbuda": "安地卡巴布达",
                Argentina: "阿根廷",
                Armenia: "亚美尼亚",
                Aruba: "阿鲁巴",
                Australia: "澳大利亚",
                Austria: "奥地利",
                Azerbaijan: "亚塞拜然",
                Bahamas: "巴哈马",
                Bahrain: "巴林",
                Bangladesh: "孟加拉",
                Barbados: "巴贝多",
                Belarus: "白俄罗斯",
                Belgium: "比利时",
                Belize: "贝里斯",
                Benin: "贝南",
                Bermuda: "百慕达",
                Bhutan: "不丹",
                Bolivia: "玻利维亚",
                "Bosnia-Herzegovina": "波士尼亚赫塞哥维纳",
                Botswana: "波札那",
                "Bouvet-Island": "波维特岛",
                Brazil: "巴西",
                "British-Indian-Ocean-Territory": "英属印度洋地区",
                "Brunei-Darussalam": "汶莱",
                Bulgaria: "保加利亚",
                "Burkina-Faso": "布吉纳法索",
                Burundi: "蒲隆地",
                Cambodia: "柬埔寨",
                Cameroon: "喀麦隆",
                Canada: "加拿大",
                "Cape-Verde": "维德角",
                "Cayman-Islands": "开曼群岛",
                "Central-African-Republic": "中非共和国",
                Chad: "查德",
                Chile: "智利",
                "Christmas-Island": "圣诞岛",
                "Cocos(Keeling)-Islands": "可可斯群岛",
                Colombia: "哥伦比亚",
                Comoros: "葛摩",
                Congo: "刚果",
                "Cook-Islands": "库克群岛",
                "Costa-Rica": "哥斯大黎加",
                "Cote-D'Ivoire": "象牙海岸",
                Croatia: "克罗埃西亚",
                Cuba: "古巴",
                Cyprus: "塞普勒斯",
                "Czech-Republic": "捷克",
                "Democratic-People's-Republic-of-Korea": "北韩",
                Denmark: "丹麦",
                Djibouti: "吉布地",
                Dominica: "多米尼克",
                "Dominican-Republic": "多明尼加",
                Ecuador: "厄瓜多",
                Egypt: "埃及",
                El: "萨尔瓦多",
                Equatorial: "赤道几内亚",
                Eritrea: "厄利垂亚",
                Estonia: "爱沙尼亚",
                Ethiopia: "衣索比亚",
                "Falkland-Islands": "福克兰群岛",
                "Faroe-Islands": "法罗群岛",
                "Federated-States-of-Micronesia": "密克罗尼西亚联邦",
                Fiji: "斐济",
                Finland: "芬兰",
                France: "法国",
                "French-Guiana": "法属圭亚那",
                "French-Polynesia": "法属玻里尼西亚",
                "French-Southern-Territories": "法属南部属地",
                Gabon: "加彭",
                Gambia: "甘比亚",
                Georgia: "乔治亚",
                Germany: "德国",
                Ghana: "迦纳",
                Gibraltar: "直布罗陀",
                Greece: "希腊",
                Greenland: "格陵兰",
                Grenada: "格瑞那达",
                Guadeloupe: "哥德洛普",
                Guam: "关岛",
                Guatemala: "瓜地马拉",
                Guernsey: "根息",
                Guinea: "几内亚",
                "Guinea-Bissau": "几内亚比索",
                Guyana: "盖亚那",
                Haiti: "海地",
                "Heard-Island-and-Mcdonald-Islands": "赫德麦当奴群岛",
                "Holy-See": "教廷(梵蒂冈)",
                Honduras: "宏都拉斯",
                Hungary: "匈牙利",
                Iceland: "冰岛",
                India: "印度",
                Indonesia: "印尼",
                Iraq: "伊拉克",
                Ireland: "爱尔兰",
                "Islamic-Republic": "伊朗",
                "Isle-of-Man": "曼岛",
                Israel: "以色列",
                Italy: "意大利",
                Jamaica: "牙买加",
                Japan: "日本",
                Jersey: "泽西",
                Jordan: "约旦",
                Kazakhstan: "哈萨克",
                Kenya: "肯亚",
                Kiribati: "吉里巴斯",
                Kuwait: "科威特",
                Kyrgyzstan: "吉尔吉斯",
                Laos: "寮国",
                Latvia: "拉脱维亚",
                Lebanon: "黎巴嫩",
                Lesotho: "赖索托",
                Liberia: "赖比瑞亚",
                Libya: "利比亚",
                Liechtenstein: "列支敦斯登",
                Lithuania: "立陶宛",
                Luxembourg: "卢森堡",
                Madagascar: "马达加斯加",
                Malawi: "马拉威",
                Malaysia: "马来西亚",
                Maldives: "马尔地夫",
                Mali: "马利",
                Malta: "马尔他",
                "Marshall-Islands": "马绍尔群岛",
                Martinique: "马丁尼克",
                Mauritania: "茅利塔尼亚",
                Mauritius: "模里西斯",
                Mayotte: "美亚特",
                Mexico: "墨西哥",
                Monaco: "摩纳哥",
                Mongolia: "蒙古",
                Montenegro: "蒙特内哥罗",
                Montserrat: "蒙特色拉",
                Morocco: "摩洛哥",
                Mozambique: "莫三比克",
                Myanmar: "缅甸",
                Namibia: "纳米比亚",
                Nauru: "诺鲁",
                Nepal: "尼泊尔",
                Netherlands: "荷兰",
                "Netherlands-Antilles": "荷属安地列斯",
                "New-Caledonia": "新喀里多尼亚",
                "New-Zealand": "纽西兰",
                Nicaragua: "尼加拉瓜",
                Niger: "尼日",
                Nigeria: "奈及利亚",
                Niue: "纽埃",
                "Norfolk-Island": "诺福克岛",
                "Northern-Mariana-Islands": "北马里安纳群岛",
                Norway: "挪威",
                Oman: "阿曼",
                Pakistan: "巴基斯坦",
                Palau: "帛琉",
                Palestinian: "巴勒斯坦",
                Panama: "巴拿马",
                "Papua-New-Guinea": "巴布亚纽几内亚",
                Paraguay: "巴拉圭",
                Peru: "秘鲁",
                Philippines: "菲律宾",
                Pitcairn: "皮特康",
                Poland: "波兰",
                Portugal: "葡萄牙",
                "Puerto-Rico": "波多黎各",
                Qatar: "卡达",
                "Republic-of-Korea": "南韩",
                Macedonia: "马其顿",
                Moldova: "摩尔多瓦",
                Reunion: "留尼旺",
                Romania: "罗马尼亚",
                Russian: "俄罗斯",
                Rwanda: "卢安达",
                "Saint-Helena": "圣赫勒拿",
                "Saint-Kitts-Nevis": "圣克里斯多福",
                "Saint-Lucia": "圣露西亚",
                "Saint-Pierre-Miquelon": "圣皮耶密克隆",
                "Saint-Vincent-Grenadines": "圣文森",
                Samoa: "萨摩亚",
                "San-Marino": "圣马利诺",
                "Sao-Tome-Principe": "圣多美普林西比",
                "Saudi-Arabia": "沙乌地阿拉伯",
                Senegal: "塞内加尔",
                Serbia: "塞尔维亚",
                Seychelles: "塞席尔",
                "Sierra-Leone": "狮子山",
                Singapore: "新加坡",
                Slovakia: "斯洛伐克",
                Slovenia: "斯洛维尼亚",
                "Solomon-Islands": "索罗门群岛",
                Somalia: "索马利亚",
                "South-Africa": "南非",
                "South-Georgia-South-Sandwich-Islands": "南乔治亚南桑威奇群岛",
                Spain: "西班牙",
                "Sri-Lanka": "斯里兰卡",
                Sudan: "苏丹",
                Suriname: "苏利南",
                "Svalbard-Jan-Mayen": "斯瓦尔巴尖棉",
                Swaziland: "史瓦济兰",
                Sweden: "瑞典",
                Switzerland: "瑞士",
                "Syrian-Arab-Republic": "叙利亚",
                Tajikistan: "塔吉克",
                Tanzania: "坦尚尼亚",
                Thailand: "泰国",
                "The-Democratic-Republic-Congo": "刚果民主共和国",
                "Timor-Leste": "东帝汶",
                Togo: "多哥",
                Tokelau: "托克劳",
                Tonga: "东加",
                "Trinidad-Tobago": "千里达托贝哥",
                Tunisia: "突尼西亚",
                Turkey: "土耳其",
                Turkmenistan: "土库曼",
                "Turks-Caicos-Islands": "托克斯寇克斯群岛",
                Tuvalu: "吐瓦鲁",
                Uganda: "乌干达",
                Ukraine: "乌克兰",
                "United-Arab-Emirates": "阿拉伯联合大公国",
                "United-Kingdom": "英国",
                "United-States": "美国",
                "United-States-Minor-Outlying-Islands": "美属边疆群岛",
                Uruguay: "乌拉圭",
                Uzbekistan: "乌兹别克",
                Vanuatu: "万那杜",
                Venezuela: "委内瑞拉",
                "Viet-Nam": "越南",
                "Virgin-Islands-British": "英属维尔京群岛",
                "Virgin-Islands-U.S": "美属维京群岛",
                "Wallis-Futuna": "华里斯福他纳",
                "Western-Sahara": "西撒哈拉",
                Yemen: "叶门",
                Zambia: "尚比亚",
                Zimbabwe: "辛巴威",
            },
        },
        instituteOp: {
            "Chu-Hai-College": "香港珠海学院",
            "City-University": "香港城市大学",
            "Baptist-University": "香港浸会大学",
            "Metropolitan-University": "香港都会大学",
            "Shue-Yan-University": "香港树仁大学",
            "Lingnan-University": "岭南大学",
            "Tung-Wah-College": "东华学院",
            "Chinese-University": "香港中文大学",
            "Education-University": "香港教育大学",
            "Hang-Seng-University": "香港恒生大学",
            Academy: "香港演艺学院",
            "Polytechnic-University": "香港理工大学",
            "Science-Technology": "香港科技大学",
            University: "香港大学",
            Others: "其他",
        },
        programmeNameOp: {
            postgraduateDiplomaEducation: "学位教师教育文凭",
            postgraduateCertificateEducation: "学位教师教育证书",
            postgraduateDiplomaEducationPrimary: "学位教师教育文凭(小学)",
            postgraduateDiplomaEducationSecondary: "学位教师教育文凭(中学)",
            postgraduateCertificateEducationPrimary: "学位教师教育证书(小学)",
            postgraduateCertificateEducationSecondary: "学位教师教育证书(中学)",
            diplomaEducation: "教育文凭",
            certificatePrimaryEducation: "小学教育证书",
            certificateSecondaryEducation: "中学教育证书",
            certificateEducation: "教育证书",
            teacherCertificate: "教师证书",
            serviceCoursePrimary: "在职小学教师训练课程",
            serviceCourseSecondary: "在职中学教师训练课程",
            certificateEarlyChildhoodEducation: "幼儿教育证书(中文)",
            others: "其他",
        },
        secondaryEducationExaminationOp: {
            "05**": "5**",
            "05*": "5*",
            "05": "5",
            "04": "4",
            "03": "3",
            "02": "2",
            "01": "1",
        },
        advancedLevelExaminationOp: {
            A: "A",
            B: "B",
            C: "C",
            D: "D",
            E: "E",
            F: "F",
            U: "U",
        },
        GCEExaminationOp: {
            A: "A",
            B: "B",
            C: "C",
            D: "D",
            E: "E",
            U: "U",
        },
        CRELevelOp: {
            level2: "第2级",
            level1: "第1级",
            fail: "不及格",
        },
        attendanceModeOp: {
            fullTime: "全日制",
            partTime: "兼读制",
            distanceLearning: "遥距学习",
        },
        bandOp: {
            "9.0": "9.0",
            8.5: "8.5",
            "8.0": "8.0",
            7.5: "7.5",
            "7.0": "7.0",
            6.5: "6.5",
            "6.0": "6.0",
            5.5: "5.5",
            "5.0": "5.0",
            4.5: "4.5",
            "4.0": "4.0",
            3.5: "3.5",
            "3.0": "3.0",
            2.5: "2.5",
            "2.0": "2.0",
            1.5: "1.5",
            "1.0": "1.0",
            0.5: "0.5",
            "00": "0",
        },
        advancedLevelOp: {
            "05*": "5*",
            "05": "5",
            "04": "4",
            "03": "3",
            "02": "2",
            "01": "1",
            unclassified: "不予评级",
        },
        languageCommissionOp: {
            pass: "及格",
            fail: "不及格 / 未曾参加测试",
        },
        attainedOp: {
            attained: "达到",
            notAttained: "未能达到",
            exempted: "豁免",
        },
        putonghuaAttainedOp: {
            attained: "达到",
            notAttained: "未能达到",
        },
        fullTimeOrPartTimeOp: {
            fullTime: "全职",
            partTime: "兼职",
        },
        teachingOp: {
            teaching: "教学",
            nonTeaching: "非教学",
        },
        subjectOp: [
            "生物",
            "企业、会计与财务概论",
            "化学",
            "中国历史",
            "中国语文",
            "中国文学",
            "公民与社会发展/通识教育",
            "设计与应用科技",
            "经济",
            "英国语文",
            "英国文学",
            "伦理与宗教",
            "常识",
            "地理",
            "健康管理与社会关怀",
            "历史",
            "资讯及通讯科技",
            "数学",
            "音乐",
            "体育",
            "物理",
            "普通话",
            "科学",
            "科技与生活",
            "科技教育",
            "旅游与款待",
            "视觉艺术",
        ],
        levelOp: [
            "中七",
            "中六",
            "中五",
            "中四",
            "中三",
            "中二",
            "中一",
            "小六",
            "小五",
            "小四",
            "小三",
            "小二",
            "小一",
            "幼稚园高班",
            "幼稚园低班",
            "幼儿班",
        ],
        nationalSecurityResultLevelOp: {
            yes: "是",
            no: "否",
            na: "不适用",
        },
    },
    errorMsg: {
        reEnterEmail: "再次输入的电邮地址应与电邮地址相同",
        duplicatePost:
            "此电邮地址已用作申请此职位，请选择其他职位。如欲更改已提交的申请资料，请在教育局电子表格递交系统主页选择「表格查询」。",
        atLeastOnePost: "请选择至少一个职位",
        atLeastOneSubject: "请选择至少一个科目",
        duplicateHkid:
            "你输入的身份证号码已用作申请此职位，请返回上一页选择其他职位。如欲更改已提交的申请资料，请在教育局电子表格递交系统主页选择「表格查询」。",
        duplicatePassport:
            "你输入的护照/旅行证件号码已用作申请此职位，请返回上一页选择其他职位。如欲更改已提交的申请资料，请在教育局电子表格递交系统主页选择「表格查询」。",
        duplicateDeadline: "如欲申请此职位，请提交另一份申请书。",
        editPost: "如欲申请其他职位，请提交另一份申请书。",
        CREMustBeLevel2: "综合招聘考试 - 中文运用必须达到第二级",
        CREofEnMustBeLevel2: "综合招聘考试 - 英文运用必须达到第二级",
        postAppliedFor: "请选择你想申请的职位。",
        issuingAuthority: "请填写发证机关",
        permanentResident: "请选择您是否为香港特别行政区的永久性居民",
        residentialAddress: "请填写住址",
        residentialAddressRoom: "请填写单位/室",
        residentialAddressFloor: "请填写楼层",
        residentialAddressBlock: "请填写座/大厦",
        residentialAddressEstate: "请填写屋邨",
        residentialAddressRoad: "请填写道/街",
        residentialAddressDistrict: "请填写分区",
        residentialAddressCountry: "请选择国家/地区",
        correspondenceAddressDistrict: "请选择地区",
        tel1: "请填写流动电话",
        chineseNameCode: "请填写中文姓名电码",
        institute: "请选择院校",
        instituteOther: "请填写指定部分",
        attendanceMode: "请选择上课形式",
        programmeDuration: "请填写修读年期",
        awardYear: "请选择颁发/将获颁发的日期",
        majorSubject: "请填写主修科目",
        minorSubject: "请填写副修科目",
        programmeName: "请填写课程名称",
        programmeSelectName: "请选择课程名称",
        programmeNameOther: "请填写指定部分",
        institute1: "请选择颁发机构/院校名称",
        levelAttained: "请填写已达到/将达到的程度",
        dateObtained: "请选择获取/将获取资格的日期",
        secondaryEducationExamination: "请选择香港中学文凭考试的最佳成绩",
        cnCulture: "请选择中国语文及文化的最佳成绩",
        cnLiterature: "请选择中国语文、中国语言文学的最佳成绩",
        creLevel: "请选择综合招聘考试（CRE）-中文运用的最佳成绩",
        creTestDate: "请选择考试日期",
        secondaryEducationExaminationofEn: "请选择香港中学文凭考试的最佳成绩",
        enCulture: "请选择香港高级程度会考的最佳成绩",
        enCRELevel: "请选择综合招聘考试（CRE）-英语运用的最佳成绩",
        enCRETestDate: "请选择测试日期",
        overallBand: "请选择整体分级结果",
        listeningBand: "请选择听解分级结果",
        readingBand: "请选择阅读分级的结果",
        writingBand: "请选择写作分级的结果",
        speakingBand: "请选择英语会话分级的结果",
        enIELTSestDate: "请选择测试日期",
        advancedLevel: "请选择普通教育高级程度证书的结果",
        subjectTaughtOther: "请填写指定部分",
        levelTaughtOther: "请填写指定部分",
        disciplinaryOffenceDetails: "请填写在政府任职期间违反纪律的详情",
        guiltyOffenceDetails: "请填写判定有罪详情",
        natureAndDegree: "请注明残疾性质及程度",
        examinationRequired: "请列明考试特别安排的有关要求",
        interviewRequired: "请列明面试特别安排的有关要求",
        schoolName: "请填写学校/机构名称",
        fullTimeOrPartTime: "请选择全职/兼职",
        positionHeld: "请填写职位",
        natureWork: "请选择工作性质",
        subjectTaught: "请选择及/或填写任教科目",
        levelTaught: "请选择及/或填写任教年级",
        dutiesDescription: "请填写职责说明",
        form: "请选择日期",
        to: "请选择日期",
        ServiceTo: "有效时间结束应该晚于有效时间开始",
        submitTimeout: "已超时！请在进入form101后两小时内完成提交！",
        submitFail: "提交失败",
        duplicatesSubject: "同一科目于同一申请时段不可同时刊登。",
        workingExperienceMinimumYears:
            "请注意，你须符合所申请职位在取得学士学位所需的工作经验要求。",
        differentJob:
            "“{{differentJob}}”职位处于“发布”状态，并且内容有改动，请确认是否保存？",
        duration: "请填写日期",
        workingExperienceInputNullData: "请填写工作经验",
        requiredWithName: "请填写{{fieldName}}",
        requiredWithSelect: "请选择{{fieldName}}",
        atLeastOne: "请填写以上其中一项",
        atLeastOneOfItems: "请填写(ii) / (iii)其中一项",
        numericOnly: "仅限数字",
        maxDigits: "最多 {{digits}} 位数字",
        enIELTSestDateMinDate: "考试日期要在{{startDate}}至{{endDate}}才有效",
        enIELTSestDateMinDateNew:
            "IELTS考试成绩(两年有效期)必须在职位接受申请期内任何一日均为有效。",
        leastOneQualification: "请在下面至少填写一项资格。",
        leastOneResultCn: "请在下面输入至少一个中文科目的成绩。",
        leastOneResultEn: "请在下面输入至少一个英文科目的成绩。",
        importantNotes: "请在方格内加上“√”号，然后按「继续」键。",
        engSurnameRequired: "请填写姓氏",
        engSurnameValid: "请输入一个有效的姓氏",
        englishOtherNameRequired: "请填写名字",
        englishOtherNameValid: "请输入有效的名字",
        hkidOrPassport: "请填写香港身份证号码或护照/旅行证件号码",
        passportValid: "请输入有效的护照/旅行证件号码",
        hkidValid: "请输入有效的香港身份证号码",
        requiredAgreement: "请在方格内加上“√”号以确认接受相关条款。",
        nationalSecurityResult: "请选择适用答案",
        workFrom: "请选择开始的日期",
        workTo: "请选择结束的日期",
        grade: "请输入级别",
        obtainedDateOfMY: "请选择有效期",
        maxTextLength: "不可超过{{max}}个字符",
        gceExaminationsLevel: "请输入已达到的级别",
        igcseForEnglishLevel: "请输入已达到的级别",
        instituteMembershipLevel: "请输入类别",
        schoolOrDivision: "请填写学校/分部/分组",
        fromDate: "请选择起始日期",
        toDate: "请选择结束日期",
        selectDate: "请选择日期",
        selectoPtion: "请选择一个选项",
        duplicatePublishJob:
            "“{{duplicatePublishJob}}”职位已存在“发布”状态，请勿重複发布相同职位。",
    },
    editDialog: {
        title: "通知",
        note: "你的申请表已更新。",
        msg: "请注意，你还未完成及确认在申请书所作的更改。如仍需更改申请资料，请在完成修改后前往最后确认页面按“提交”按钮。",
    },
};

export default Form101TC;
